import React from 'react';
import { Typography } from '@mui/material';
import AqiqahPediaLogo from '../../assets/images/logo.png';

const Header = () => (
  <>
    <img src={AqiqahPediaLogo} alt="AqiqahPedia Logo" style={{ width: '150px', height: 'auto', alignSelf: 'center' }} />
    <Typography
      component="h1"
      variant="h4"
      sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
    >
      Formulir Pemesanan 
    </Typography>
  </>
);

export default Header;